import Image from 'components/shared/image/image';
import cn from 'classnames';
import styles from './buyingPros.module.scss';

const BuyingPros = ({ data, className }) => {
  const { prosAndIcons } = data;

  return (
    <div className={cn(styles.buyingProsCard, className)}>
      {prosAndIcons?.map((proAndIcon, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={styles.proAndIcon} key={`${proAndIcon.icon.contentType}${i}`}>
          <Image className={styles.icon} layout="responsive" src={proAndIcon.icon} />
          <p className={styles.proText}>{proAndIcon.text}</p>
        </div>
      ))}
    </div>
  );
};

export default BuyingPros;
